import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { handleErrors } from "~/src/utils/errors";

export const UPDATE_MEMBER_PREFERENCES = gql`
  mutation updateMemberPreferences($memberId: ID!, $preferences: JSON!) {
    createOrUpdateMemberPreferences(
      memberId: $memberId
      preferences: $preferences
    ) {
      id
      memberId
      preferences
      updatedAt
    }
  }
`;

export default graphql(UPDATE_MEMBER_PREFERENCES, {
  props: handleErrors(({ mutate }) => ({
    updateMemberPreferences: (memberId, preferences) =>
      mutate({
        variables: { memberId, preferences },
        optimisticResponse: {
          __typename: "Mutation",
          createOrUpdateMemberPreferences: {
            __typename: "memberPreferences",
            id: memberId, // This is just a placeholder for optimistic UI
            memberId: memberId,
            preferences: preferences,
            updatedAt: new Date().toISOString()
          }
        }
      })
  }))
});
